exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.pagination[data-v-5dc48164] {\n  margin: 0 1rem;\n}\n.pagination .text-quantity[data-v-5dc48164] {\n    padding-left: 1rem;\n    padding-right: 1rem;\n    font-weight: 500;\n    color: #333;\n}\n.pagination .minus[data-v-5dc48164], .pagination .plus[data-v-5dc48164] {\n    font-weight: 500;\n    color: #888;\n}\n.btn-cart[data-v-5dc48164] {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  font-weight: 500;\n}\n.text-price[data-v-5dc48164] {\n  font-size: 0.875rem;\n  margin-left: 1rem;\n  font-weight: 400;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5dc48164","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ProductDetailView.vue
// module id = K4V1
// module chunks = 14